import { Box, Dialog, Grid, IconButton, Typography } from '@mui/material';
import React, {useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { toast } from 'react-toastify';
import CustomTextField from '../../../Components/CustomTextField/CustomTextField';
import CustomSubmitButton from '../../../Components/CustomSubmitButton/CustomSubmitButton';
import AxiosInstance from '../../../Config/AxiosInstance';
import APILIST from '../../../Config/ApiList';
const AddBlogCategory = (props) => {
    const { open, onClose, typeCheck, editBlogCategoryData, handleOnSubmit, handleOnClose } = props;
    console.log('typeCheck', typeCheck);
    
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (typeCheck === 'EDIT') {
            formik.setValues({
                category_name: editBlogCategoryData?.category_name || "",
            })
        } else {
          formik.resetForm();
        }
      }, [typeCheck]);
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            category_name: "",
        },
        validationSchema: Yup.object().shape({
            category_name: Yup.string().required("Category name is required"),
        }),
        onSubmit: async (values, { resetForm }) => {
            setIsLoading(true);
            if (isLoading) {
                return;
            } else {
                try {
                    const formData = new FormData();
                    if (typeCheck === "EDIT") {
                        formData.append('id', editBlogCategoryData?.id);
                    }
                    formData.append('category_name', values.category_name);
                    const apiEndpoint = typeCheck === "EDIT" ? APILIST.UPDATE_DELETE_BLOG_CATEGORY : APILIST.ADD_BLOG_CATEGORY;
                    const response = await AxiosInstance.post(apiEndpoint, formData);

                    if (response && response.data?.s) {
                        toast.success(typeCheck === "EDIT" ? 'Blog Category Updated Successfully!' : 'Blog Category Added Successfully!');
                        resetForm();
                        handleOnSubmit()
                    } else {
                        toast.error('An unexpected error occurred');
                    }
                } catch (error) {
                    toast.error(error.message || 'An error occurred');
                } finally {
                    setIsLoading(false);
                }
            }
        },
    });
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            sx={{
                "& .MuiPaper-root": {
                    borderRadius: "20px",
                    padding: '20px 30px',
                    height: "260px",
                    overflow: "scroll",
                    "::-webkit-scrollbar": { width: "0px", height: '0px' }
                },
                "& .MuiDialogContent-root": {
                    overflowY: "initial",
                },
                "& .MuiBackdrop-root": {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                }
            }}
        >
            <form onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
                return false;
            }}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Typography sx={{ fontSize: '20px', fontWeight: '500', color: '#101010', fontFamily: "Outfit" }}>{typeCheck ? "Update" : "Add"} Blog Category</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end'
                        }}>
                            <IconButton sx={{
                                width: '30px',
                                height: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: '#101010',
                                borderRadius: '8px',
                                "&:hover": {
                                    backgroundColor: '#101010',
                                    color: '#fff',
                                }
                            }} onClick={handleOnClose}>
                                <CloseIcon sx={{ color: '#fff', fontSize: '20px' }} />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{
                    padding: '20px 0px 0px 0px',
                }}>
                    <Grid spacing={2} container>
                        <Grid item xs={12}>
                            <CustomTextField
                                label="Category Name"
                                type="text"
                                placeholder="Category Name"
                                name="category_name"
                                value={formik.values.category_name}
                                onBlur={formik.handleBlur}
                                onKeyUp={formik.handleBlur}
                                errors={formik.touched.category_name && formik.errors.category_name}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (value.trimStart() !== value) {
                                        e.target.value = value.trimStart();
                                    }
                                    formik.handleChange(e);
                                }}
                                sx={{
                                    "& .MuiInputBase-root": {
                                        borderRadius: "10px",
                                        border: formik.errors.category_name ? "1px solid red" : "1px solid #BB9EFF",
                                        color: "black",
                                        fontSize: "18px",
                                        background: "white",
                                        fontFamily: "Outfit",
                                    },
                                }}
                                style={{ color: "black", fontSize: "18px" }}
                                isLoading={isLoading}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <CustomSubmitButton
                                btnTitle={typeCheck ? "Update Blog Category" : "Add Blog Category"}
                                loading={isLoading}
                                type="submit"
                            />
                        </Grid>
                    </Grid>
                </Box>
            </form>
        </Dialog>
    );
};

export default AddBlogCategory;